<template>
  <!--video-->
  <div
    ref="modalVideoPlayer"
    class="modal fade"
    id="modalvideoplayer"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalvideoplayerLabel"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="modal-title">
            <i class="far fa-file-video mr-2" />{{ title }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="clickClose()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <VideoPlayer
          ref="videoPlayer"
          :videosrc="videoSrc"
          :videotype="videoType" 
          :videocover="videoCover"
          :lastcurrenttime="lastCurrentTime"
          :speedrate="speedRate"
          :volume="volumeValue"
          :autoplay="autoPlay"
          :muted="mutedValue"
          :loop="loopValue"
          :control="controlValue"
          :controlbtns="controlBtns"
          :qualitylist="qualityList"
          @onPlayCallback="onPlayCallback"
          @onPauseCallback="onPauseCallback"
          @onTimeupdateCallback="onTimeupdateCallback"
          @onEndCallback="onEndCallback"
          @onErrorCallback="onErrorCallback"
          @onScreenChangeCallback="onScreenChangeCallback"
          @onPrevVideoCallback="onPrevVideoCallback"
          @onNextVideoCallback="onNextVideoCallback"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line no-unused-vars
import { h, ref, toRefs, reactive , watch , inject , onMounted , onUpdated, onBeforeUpdate, nextTick } from 'vue';
import { VideoPlayer } from '@/components/VideoPlayer' ;
      
export default {
  name: 'VideoPalyer',
  components: {
    VideoPlayer,
  },
  props: {
    videosrc: {
      type: String,
      required:true
    },
    videotype: {
      type: String,
      required:false,
      default(){
        return 'm3u8';
      }
    },
    videocover: {
      type: String,
      required:true
    },
    lastcurrenttime: {
      type: Number ,
      required:false,
      default(){
        return 0;
      }
    },
    speedrate: {
      type: Number ,
      required:false,
      default(){
        return 1;
      }
    },
    volume: {
      type: Number,
      required:false,
      default(){
        return 50;
      }
    },
    autoplay: {
      type: Boolean ,
      required:false,
      default(){
        return false;
      }
    },
    muted: {
      type: Boolean ,
      required:false,
      default(){
        return false;
      }
    },
    loop: {
      type: Boolean ,
      required:false,
      default(){
        return false;
      }
    },
    control:{
      type: Boolean,
      required:false,
      default(){
        return false;
      }
    },
    controlbtns:{
      type: Array,
      required:false,
      default(){
        return [];
      }
    },
    qualitylist:{
      type: Array,
      required:false,
      default(){
        return [];
      }
    },    
    title: {
      type: String,
      required:false,
      default(){
        return '';
      }
    },
  },
  emits: [
    'onPlayCallback', 
    'onPauseCallback', 
    'onTimeupdateCallback', 
    'onEndCallback', 
    'onErrorCallback', 
    'onScreenChangeCallback',
    'onPrevVideoCallback',
    'onNextVideoCallback',
  ], 
  setup(props,{emit}) {
    const {
      videosrc,
      videotype,
      videocover,
      lastcurrenttime,
      speedrate,
      volume,
      autoplay,
      muted,
      loop,
      control,
      controlbtns,
      qualitylist,
      title,
    } = toRefs(props);

    const videoPlayer = ref(null);
    const modalVideoPlayer = ref();
    
    // 用於儲存父元件傳遞的值 & 傳遞給子元件的變數
    const videoSrc = ref('');
    const videoType = ref('');
    const videoCover = ref('');
    const lastCurrentTime = ref(0);  
    const speedRate = ref(1);  
    const volumeValue = ref(50);
    const autoPlay = ref(false);
    const mutedValue = ref(false);
    const loopValue = ref(false);
    const controlValue = ref(true); // 預設必須是 true，不然 template 元件不顯示，後面的流程都錯了
    const controlBtns = ref([]);
    const qualityList = ref([]); // 解析度清單
    
    watch(videosrc, (newValue)=>{
      videoSrc.value = newValue;
    });
    
    watch(videotype, (newValue)=>{
      videoType.value = newValue;
    });
    
    watch(videocover, (newValue)=>{
      videoCover.value = newValue;
    });
    
    watch(lastcurrenttime, (newValue)=>{
      lastCurrentTime.value = newValue;
    });
    
    watch(speedrate, (newValue)=>{
      speedRate.value = newValue;
    });
    
    watch(volume, (newValue)=>{
      volumeValue.value = newValue;
    });
    
    watch(autoplay, (newValue)=>{
      autoPlay.value = newValue;
    });
    
    watch(muted, (newValue)=>{
      mutedValue.value = newValue;
    });
    
    watch(loop, (newValue)=>{
      loopValue.value = newValue;
    });
    
    watch(control, (newValue)=>{
      controlValue.value = newValue;
    });
    
    watch(controlbtns, (newValue)=>{
      controlBtns.value = newValue;
    });
    
    watch(qualitylist, (newValue)=>{
      qualityList.value = newValue;
    });
              
    // 播放器 Event Start -------------------
    function onPlayCallback(event){
      emit('onPlayCallback', event);
    }
    
    function onPauseCallback(event){
      emit('onPauseCallback', event);
    }
    
    function onTimeupdateCallback(res){
      emit('onTimeupdateCallback', res);
    }
    
    function onEndCallback(event){
      emit('onEndCallback', event);
    }
    
    function onErrorCallback(event){
      emit('onEndCallback', event);
    }
    
    function onScreenChangeCallback(res){
      emit('onScreenChangeCallback', res);
    }
    
    function onPrevVideoCallback(value){
      emit('onPrevVideoCallback', value);
    }
    
    function onNextVideoCallback(value){
      emit('onNextVideoCallback', value);
    }
    
    // 播放器 Function End -------------------
    
    
    onMounted(async () => {
      // 將父元件透過 props 傳入的資料，更新至變數
      initVideoVar();

      // 檢查觸發開啟的物件是否被點擊，強制綁定 modal-for-video-player
      let elements = document.getElementsByClassName('modal-for-video-player');

      if(elements != null && elements.length > 0){
        for (let i = 0; i < elements.length; i++) {
          elements[i].addEventListener('click', (event) => {
            if(videoPlayer.value != null){
              // 重整畫面，不然會縮圖、黑底都會跑位
              videoPlayer.value.windowResize();
            }
          });
        }
      }
    });
    
    function initVideoVar(){
      //console.log('initVideoVar');
      videoSrc.value = videosrc.value;
      videoType.value = videotype.value;
      videoCover.value = videocover.value;
      lastCurrentTime.value = lastcurrenttime.value;
      speedRate.value = speedrate.value;
      volumeValue.value = volume.value;
      autoPlay.value = autoplay.value;
      mutedValue.value = muted.value;
      loopValue.value = loop.value;
      controlValue.value = control.value;
      controlBtns.value = controlbtns.value;
      qualityList.value = qualitylist.value;
    }

    function clickClose(){
      if(videoPlayer.value != null){
        videoPlayer.value.togglePlay(false);
      }
    }
      
    return {
      videoPlayer,
      modalVideoPlayer,
      // Component Video Params      
      videoSrc,
      videoType,
      videoCover,
      lastCurrentTime,
      speedRate,
      volumeValue,
      autoPlay,
      mutedValue,
      loopValue,
      controlValue,
      controlBtns,
      qualityList,
    
      // Component Video Event
      onPlayCallback,
      onPauseCallback,
      onTimeupdateCallback,
      onEndCallback,
      onErrorCallback,
      onScreenChangeCallback,    
      onPrevVideoCallback,
      onNextVideoCallback,

      // function
      clickClose,
    };
  },
};
</script>